import React, { Component } from 'react';
import { formatoDecimal } from '../../utilities/formatoNumeros'
import { getLogoPlataformaById, getLabelEstadoById } from "../../helper/ordenHelper";

export default class OrdenListItem extends Component {
    render = () => {
        const {
            idOrden,
            idReferencia,
            seller,
            fecha,
            cliente,
            estado,
            tipoEntrega,
            montoVenta,
            productos,
            mailCliente,
            dniIdBocaSeller,
            plataformaCodigo,
            showComision,
            importeComision,
            anulacionMegatone
        } = this.props;
        const changeTipoEntrega = (tipoEntrega) => {
            if (!tipoEntrega) return;
            return (tipoEntrega.includes("sucursal correo")) ? "Env\u00CDo a domicilio" : tipoEntrega;
        }

        // ...existing code...
        // Validación segura para estado
        const estadoValido = Array.isArray(estado) && estado.length > 0 ? estado[0] : null;
        return (
            <div className="container list-group-item hover-background-color">
                <div className="row align-items-center text-center text-break">
                    <div className="col-12 col-md-2">
                        <h6 className="font-weight-bold">{seller}</h6>
                        <span className="d-block font-size-072rem">{fecha?.slice(0, 10)}</span>
                        <span className="d-block font-size-072rem">{idOrden}</span>
                        {idReferencia && (
                            <>
                                <span className="d-block font-size-072rem">Id Referencia</span>
                                <span className="d-block font-size-072rem">{idReferencia}</span>
                            </>
                        )}
                    </div>
                    <div className="col-12 col-md-2">
                        <small className="font-14 font-weight-bold applyFont d-block my-1">{cliente}</small>
                        <small hidden={!mailCliente || mailCliente.length < 1} className="applyFont d-block my-1">{mailCliente}</small>
                        <img src={getLogoPlataformaById(plataformaCodigo)} alt="" style={{ width: "50px" }} className="my-1" />
                        <small className="d-block fw-bold mt-1">{dniIdBocaSeller != 0 ? dniIdBocaSeller : ""}</small>
                    </div>
                    <div className="col-12 col-md-5">
                        {Array.isArray(productos) && productos.map((producto, i, { length }) => (
                            <div className="row align-items-center justify-content-center" key={i}>
                                <div className="col-12 col-md-3">
                                    <img alt="user-img" className="mw-60px img-responsive" src={producto.imagenPrincipal ?? "https://www.megatone.net/Images/Marketplaces/EnProceso_zoom2x.png"} />
                                </div>
                                <div className="col-md-9">
                                    <h6 className="box-title m-b-5 font-weight-bold">
                                        <small className="applyFont">{producto.cantidad}x </small>{producto.titulo}
                                    </h6>
                                    <small className="applyFont d-block">Precio unitario: ${formatoDecimal(producto.precioUnitario)}</small>
                                    <small className="applyFont d-block">SKU Seller: {producto.sellerSku}</small>
                                    <small className="applyFont d-block">SKU Market: {producto.skuMarket}</small>
                                </div>
                                <div className="col-9 col-md-10 border-bottom" hidden={i + 1 === length} />
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="row">
                            <div className="col-12 col-xxl-7">
                                <h5 className="font-weight-bold box-title d-block">${formatoDecimal(montoVenta)}</h5>
                                <br />
                                {showComision && <h5 className="box-title d-block">${formatoDecimal(importeComision)}</h5>}
                            </div>
                            <div className="col-12 col-xxl-5">
                                   {idReferencia == 0 &&
                                    <>
                                        <span className={`label label-${getLabelEstadoById(estado[0]?.idEstado).color}`}>
                                            {getLabelEstadoById(estado[0]?.idEstado).label}
                                        </span>
                                        <small className="d-block my-1">{changeTipoEntrega(tipoEntrega)}</small>
                                    </>
                                }
                                {anulacionMegatone?.anulado && 
                                    <div>
                                        <span className={`label label-${getLabelEstadoById(5).color}`}>
                                            {getLabelEstadoById(5).label}
                                        </span>
                                        <small className="d-block my-1">{anulacionMegatone?.motivoAnulacion ?? ""}</small>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}